// extracted by mini-css-extract-plugin
module.exports = {"section":"PreviewSection_section_1LPu6","slides":"PreviewSection_slides_rssq4","play":"PreviewSection_play_1r-La"};